
import ConnectorChart, { ConnectorEnergyConsumptionChart } from "./Analysis/ConnectorChartComp"
import SingleConnectorInfo from "./Info/SingleConnectorInfo"
import { QRCodeConnector } from "./QRCode/QRCode"

export const SingleConnector = {
    Info :SingleConnectorInfo,
    QRCode : QRCodeConnector,
    Analysis: {
        EnergyConsumptionChart : ConnectorEnergyConsumptionChart,
        GenericChart: ConnectorChart
    }
}

export default SingleConnector
